import React from "react";

import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/arrow_right.svg";

import styles from "./Welcome.module.scss";

type Props = {
  onClose: () => void;
  onSelectIntroduction: () => void;
  onSelectGroupWork: () => void;
};

const Welcome: React.FC<Props> = ({
  onClose,
  onSelectIntroduction,
  onSelectGroupWork,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.textContainer}>
          <h1 className={styles.headerText}>
            こんにちは！先生の授業づくりを応援するよ！
          </h1>
        </div>
        <button className={styles.closeButton}>
          <CloseIcon onClick={onClose} />
        </button>
      </div>
      <div className={styles.content}>
        <p>
          先生が教えてくれた情報から、「授業で使える先生だけのアイデア」を考えたよ！
          <br />
          指導書や投影画面で授業準備をしながら確認してみてね。
        </p>
        <div className={styles.buttonContainer}>
          <button onClick={onSelectIntroduction}>
            導入トークのアイデアを見る <RightArrowIcon />
          </button>
          <button onClick={onSelectGroupWork}>
            グループワークのアイデアを見る <RightArrowIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
